<div style="background-color: rgba(0, 0, 0, 0.47);">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button> 
    <iframe src="assets/player-shaka.html" style="border: none;      
    height: 100vh;  
    width: 90vw;  overflow: hidden; " scrolling="no"></iframe>
    </div>